export default {
  scriptText: {
    "ui:widget": "textarea",
    "ui:options": {
      rows: 4,
    },
  },
  masterScript: {
    id: {
      "ui:widget": "hidden",
      "ui:readonly": true,
    },
  },
  isActive: {
    "ui:widget": "hidden",
  },
};
